import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Components/Home/Home';
import NavBar from './Components/Home/NavBar';
import Section1 from './Components/Home/Section1';
import WhoWeServe from './Components/Home/WhoWeServe';
import WhatWeDo from './Components/Home/WhatWeDo';
import Testimonials from './Components/Home/Testimonials';
import Footer from './Components/Home/Footer';
import AboutUs from './Components/Home/AboutUs';
import OurTeam from './Components/Home/OurTeam';
import ContactUs from './Components/Home/ContactUs';
import Partnership from './Components/Home/Partnership';
import OnePersonCompany from './Components/Home/OnePersonCompany';
import LimitedLiabilityPartnership from './Components/Home/LimitedLiabilityPartnership';
import PrivateLimitedCompany from './Components/Home/PrivateLimitedCompany';
import TrustRegistration from './Components/Home/TrustRegistration';
import SocietyRegistration from './Components/Home/SocietyRegistration';
import GSTAdvisoryAndCompliance from './Components/Home/GSTAdvisoryAndCompliance';
import GSTLitigationServices from './Components/Home/GSTLitigationServices';
import GSTRegistration from './Components/Home/GSTRegistration';
import GSTRegistrationServices from './Components/Home/GSTRegistrationServices';
import GSTAnnualReturn from './Components/Home/GSTAnnualReturn';
import GSTEWayBill from './Components/Home/GSTEWayBill';
import AnnualCompliancePrivateLimited from './Components/Home/AnnualCompliancePrivateLimited';
import AnnualComplianceLLP from './Components/Home/AnnualComplianceLLP';
import ProprietorshipRegistration from './Components/Home/ProprietorshipRegistration';
import TaxAuditOverview from './Components/Home/TaxAuditOverview';
import CertificationServices from './Components/Home/CertificationServices';
import ShopAndEstablishmentActIndia from './Components/Home/ShopAndEstablishmentActIndia';
import UdyogAadharRegistration from './Components/Home/UdyogAadharRegistration';
import FSSAIRegistrationLicense from './Components/Home/FSSAIRegistrationLicense';
import TrademarkRegistrationIndia from './Components/Home/TrademarkRegistrationIndia';
import ImporterExporterCodeIndia from './Components/Home/ImporterExporterCodeIndia';
import ISOCertificationIndia from './Components/Home/ISOCertificationIndia';
import RERARegistrationIndia from './Components/Home/RERARegistrationIndia';
import TradeLicenseIndia from './Components/Home/TradeLicenseIndia';
import ProfessionalTaxIndia from './Components/Home/ProfessionalTaxIndia';
import SeoRouter from './seo/SeoRouter';


function App() {
  
  return (
    <Router>
      <SeoRouter />
     
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="" element={<NavBar />} />
        <Route path="" element={<Section1 />} />
        <Route path="" element={<WhoWeServe />} />
        <Route path="" element={<WhatWeDo />} />
        <Route path="" element={<Testimonials />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/ourteam" element={<OurTeam />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/partnership" element={<Partnership />} />
        <Route path="/gstannualreturn" element={<GSTAnnualReturn />} />
        <Route path="/gstreturns" element={<GSTRegistrationServices />} />
        <Route path="/trustregistration" element={<TrustRegistration />} />
        <Route path="/societyregistration" element={<SocietyRegistration />} />
        <Route path="/gstadvisoryandcompliance" element={<GSTAdvisoryAndCompliance />} />
        <Route path="/gstlitigationservices" element={<GSTLitigationServices />} />
        <Route path="/annualcomplianceprivatelimited" element={<AnnualCompliancePrivateLimited />} />
         <Route path="/taxauditoverview" element={<TaxAuditOverview/>} />
         <Route path="/certificationservices" element={<CertificationServices />} />
         <Route path="/gstewaybill" element={<GSTEWayBill />} />
        <Route path="/proprietorshipregistration" element={<ProprietorshipRegistration />} />
         <Route path="/annualcompliancellp" element={<AnnualComplianceLLP />} />
        <Route path="/gstregistration" element={<GSTRegistration />} />
        <Route path="/OnePersonCompany" element={<OnePersonCompany />} />
        <Route path="/limitedLiabilityPartnership" element={<LimitedLiabilityPartnership />} />
        <Route path="/privatelimitedcompany" element={<PrivateLimitedCompany />} />
        <Route path="/shopandestablishmentactIndia" element={<ShopAndEstablishmentActIndia />} />
         <Route path="/udyogaadharregistration" element={<UdyogAadharRegistration />} />
         <Route path="/fssaigegistrationlicense" element={<FSSAIRegistrationLicense />} />
         <Route path="/trademarkregistrationindia" element={<TrademarkRegistrationIndia />} />

         <Route path="/importerexportercodeindia" element={<ImporterExporterCodeIndia />} />
         <Route path="/isocertificationindia" element={<ISOCertificationIndia />} />
         <Route path="/reraregistrationindia" element={<RERARegistrationIndia />} />
         <Route path="/tradelicenseindia" element={<TradeLicenseIndia />} />
         <Route path="/professionaltaxindia" element={<ProfessionalTaxIndia />} />

        <Route path="" element={<Footer />} />

      </Routes>
    </Router>
  );
}

export default App;















